import { render, staticRenderFns } from "./Bargainlist.vue?vue&type=template&id=003f44c7&scoped=true&"
import script from "./Bargainlist.vue?vue&type=script&lang=js&"
export * from "./Bargainlist.vue?vue&type=script&lang=js&"
import style0 from "./Bargainlist.vue?vue&type=style&index=0&id=003f44c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f44c7",
  null
  
)

export default component.exports